module.exports = fox._r("images/emoji/gift-107.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/emoji/gift-107.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/emoji/gift-107.png
// module id = 308
// module chunks = 4